import React from "react";

export default class ErrorBoundaryComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        console.log(error.stack.value);
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    async componentDidCatch(error, errorInfo) {
        // You can also log the error to an error reporting service
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return this.props.placeholder;
        }

        return this.props.children;
    }
}
